module.exports = __webpack_public_path__ + "img/bonchorang.04051e36.svg";